module.exports = require('./ProviderView')
